/**
 * Normalize a trading symbol for use in API path parameters.
 *
 * Converts display formats like "BTC/USD" or "BTC-USD" to the
 * API-safe format "BTC_USD". This avoids percent-encoding issues
 * where reverse proxies (nginx/Traefik) decode %2F back to "/",
 * breaking route matching in the backend.
 *
 * The backend performs identical normalization as defense-in-depth,
 * so double-normalization (e.g. "BTC_USD" → "BTC_USD") is safe.
 */
export function normalizeSymbolForApi(symbol: string): string {
  if (!symbol) {
    throw new Error('normalizeSymbolForApi: symbol must be a non-empty string');
  }
  return symbol.replace(/\//g, '_').replace(/-/g, '_').toUpperCase();
}
